import * as yup from 'yup';

export const getReplaceFormValidation = (hasSecondField) =>
  yup.object().shape({
    sectionIdx: yup.string().required('Section is required field'),
    itemIdx: hasSecondField ? yup.string().required('Item is required field') : yup.string(),
  });
